import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import {
  onAuthStateChanged,
  EmailAuthProvider,
  reauthenticateWithCredential,
  signOut,
} from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import TopNav from "../components/TopNav";
import AuthPage from "./AuthPage";

import "../App.css";

function Account() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  //   const navigate = useNavigate();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        setUser(null);
      } else {
        setUser(currentUser);
        const userDoc = await getDoc(doc(db, "users", currentUser.uid));
        if (userDoc.exists()) {
          setUserData({ ...userDoc.data(), deletePassword: "" });
        } else {
          setUserData({
            name: currentUser.displayName || "",
            email: currentUser.email,
            deletePassword: "",
          });
        }
      }
    });

    return () => unsubscribe();
  }, []);

  if (!user) return <AuthPage />;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;
    await setDoc(doc(db, "users", user.uid), userData, { merge: true });
    alert("Profile updated!");
    setIsEditing(false);
  };

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to log out?");
    if (confirmed) signOut(auth);
  };

  const handleDeleteAccount = async () => {
    if (!userData?.deletePassword) {
      alert("Please enter your password.");
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete your account? This cannot be undone."
    );
    if (!confirmed) return;

    try {
      const credential = EmailAuthProvider.credential(
        user.email,
        userData.deletePassword
      );

      await reauthenticateWithCredential(user, credential);
      await setDoc(doc(db, "users", user.uid), {}, { merge: true });
      await user.delete();
      alert("Account deleted.");
    } catch (err) {
      if (err.code === "auth/wrong-password") {
        alert("Password incorrect.");
      } else {
        alert("Error deleting account");
      }
    }
  };

  return (
    <div className="auth-container">
      <TopNav />
      <div className="account-section">
        <div className="account-header">
          <h2>My Account</h2>
          <button className="edit-btn" onClick={() => setIsEditing(!isEditing)}>
            {isEditing ? "Cancel" : "Edit"}
          </button>
        </div>

        <div className="account-details">
          <form onSubmit={handleSubmit}>
            <label>
              <strong>Name:</strong>
              {isEditing ? (
                <input
                  type="text"
                  name="name"
                  value={userData?.name || ""}
                  onChange={handleChange}
                />
              ) : (
                <span> {userData?.name || "-"}</span>
              )}
            </label>

            <label>
              <strong>Email:</strong>
              <span> {userData?.email || "-"}</span>
            </label>

            <label>
              <strong>Phone:</strong>
              {isEditing ? (
                <input
                  type="text"
                  name="phone"
                  value={userData?.phone || ""}
                  onChange={handleChange}
                />
              ) : (
                <span> {userData?.phone || "-"}</span>
              )}
            </label>

            <label>
              <strong>Area:</strong>
              {isEditing ? (
                <input
                  type="text"
                  name="area"
                  value={userData?.area || ""}
                  onChange={handleChange}
                />
              ) : (
                <span> {userData?.area || "-"}</span>
              )}
            </label>

            {isEditing && (
              <button className="auth-btn login_btn" type="submit">
                Save Changes
              </button>
            )}
          </form>
        </div>

        <div className="account-actions">
          <button
            className="auth-btn logout-btn"
            type="button"
            onClick={handleLogout}
          >
            Log Out
          </button>

          <div className="delete-account-box">
            <div className="delete-account-box">
              {!showDeleteConfirm ? (
                <button
                  className="auth-btn delete-btn"
                  type="button"
                  onClick={() => setShowDeleteConfirm(true)}
                >
                  Remove Account
                </button>
              ) : (
                <>
                  <input
                    type="password"
                    name="deletePassword"
                    placeholder="Enter password to delete"
                    className="delete-password-input"
                    value={userData?.deletePassword || ""}
                    onChange={handleChange}
                  />
                  <button
                    className="auth-btn delete-btn"
                    type="button"
                    onClick={handleDeleteAccount}
                  >
                    Confirm Delete
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Account;
